// extracted by mini-css-extract-plugin
module.exports = {"container":"RestaurantLogo_container__DMIwq","imageBox":"RestaurantLogo_imageBox__0l7j_","noBackground":"RestaurantLogo_noBackground__7r1Pn","logo":"RestaurantLogo_logo__K2pSQ"};